export default import.meta.ROLLDOWN_FILE_URL_HpZp4YFLb8PVmX83GxzrAg